import { render, staticRenderFns } from "./marketing.pug?vue&type=template&id=02465182&lang=pug&"
import script from "./marketing.ts?vue&type=script&lang=ts&"
export * from "./marketing.ts?vue&type=script&lang=ts&"
import style0 from "./marketing.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports